import React from "react";

// Fase B · Motivos de excepción de evidencia fotográfica (mismo catálogo que backend MOTIVOS_EVIDENCIA)
export const MOTIVOS_EVIDENCIA = [
  { k: "acceso_seguridad", label: "🚧 Acceso imposible / seguridad" },
  { k: "espacio_cerrado_ocupado", label: "🔒 Espacio ocupado o cerrado" },
  { k: "cliente_no_permite", label: "🙅 Cliente / centro no permite fotos" },
  { k: "incidencia_tecnica", label: "📵 Incidencia técnica / cámara" },
  { k: "trabajo_parcial", label: "🧩 Trabajo parcial / incidencia" },
  { k: "otro", label: "✏️ Otro (explica)" },
];

export const motivoLabel = (k) => MOTIVOS_EVIDENCIA.find((m) => m.k === k)?.label?.replace(/^\S+\s/, "") || k;

export function motivoValido(motivo, detalle) {
  if (!motivo) return "Elige un motivo";
  if (motivo === "otro" && !(detalle || "").trim()) return "Explica el motivo";
  return null;
}

export function MotivoEvidenciaPicker({ motivo, detalle, onMotivo, onDetalle, testPrefix = "motivo-evidencia" }) {
  return (
    <div className="space-y-2" data-testid={`${testPrefix}-picker`}>
      <div className="grid grid-cols-2 gap-1.5">
        {MOTIVOS_EVIDENCIA.map((m) => (
          <button key={m.k} type="button" onClick={() => onMotivo(m.k)}
            data-testid={`${testPrefix}-${m.k}`}
            className={`py-2 px-2 rounded-lg border text-[11px] text-left transition-colors ${
              motivo === m.k ? "bg-amber-500/20 text-amber-100 border-amber-500/60 font-semibold" : "bg-zinc-900 border-zinc-800 text-zinc-400"
            }`}>{m.label}</button>
        ))}
      </div>
      <textarea rows={2} value={detalle} onChange={(e) => onDetalle(e.target.value)}
        data-testid={`${testPrefix}-detalle`}
        placeholder={motivo === "otro" ? "Explica el motivo (obligatorio)" : "Detalle (opcional)"}
        className="w-full bg-zinc-900 border border-zinc-800 rounded px-3 py-2 text-sm" />
    </div>
  );
}
